export default __webpack_public_path__ + "static/media/NIE_touchpoint_11.336bd99a.mp4";